import { useEmailBuilderViewport } from "../shell/emailBuilderViewportContext";
import { emailBuilderUsesVerticalLeftCanvasRail } from "../shell/canvas/emailBuilderCanvasRailLayoutConstants";

export function useEmailBuilderRailViewport() {
  const {
    isMobileLayout,
    usesDesktopRightSettingsPanel,
    usesCompactSettingsChrome,
  } = useEmailBuilderViewport();

  const usesVerticalLeftRail = emailBuilderUsesVerticalLeftCanvasRail(
    usesDesktopRightSettingsPanel,
    usesCompactSettingsChrome,
  );
  const usesHorizontalCompactTouchRail =
    usesCompactSettingsChrome || isMobileLayout;
  const usesSplitFormattingRail =
    usesVerticalLeftRail && !usesHorizontalCompactTouchRail;

  return {
    isMobileLayout,
    usesVerticalLeftRail,
    usesHorizontalCompactTouchRail,
    usesSplitFormattingRail,
  };
}
